export const LOAD_UI = 'LOAD_UI';
export const loadUi = () => ({
    type: LOAD_UI,
});

export const WAIT_UI = 'WAIT_UI';
export const waitUi = () => ({
    type: WAIT_UI,
});

export const HIDE_PAX_TOOLTIP = 'HIDE_PAX_TOOLTIP';
export const hidePaxTooltip = () => ({
    type: HIDE_PAX_TOOLTIP,
});
